export const CASE_STATUS = {
  awaiting_consent: { label: "Awaiting consent", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  consent_given: { label: "Consent received", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  consent_declined: { label: "Consent declined", cls: "bg-red-50 text-red-700 border-red-200" },
  consent_expired: { label: "Link expired", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  consent_locked: { label: "Link locked", cls: "bg-red-50 text-red-700 border-red-200" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  awaiting_consent_upload: { label: "Awaiting consent form", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  in_progress: { label: "In progress", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  qa_review: { label: "QA review", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  delivered: { label: "Delivered", cls: "bg-emerald-600 text-white border-emerald-600" },
};

export const PURPOSE_LABELS = {
  insurance_underwriting: "Insurance underwriting",
  insurance_claims: "Insurance claim review",
  benefit_eligibility: "Benefit / program eligibility",
  written_consent: "Subject's written instruction",
};

export const DELIVERY_LABELS = {
  sent: "Sent",
  failed: "Failed",
  not_configured: "Not set up",
  opted_out: "Opted out (STOP)",
};

export const canOrder = (u) => ["org_admin", "requester"].includes(u?.org_role) && (!u?.org_status || u.org_status === "active");

export const StatusBadge = ({ status, testid = "case-status-badge" }) => {
  const s = CASE_STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-0.5 font-mono-label text-[9px] font-semibold ${s.cls}`} data-testid={testid}>
      {s.label.toUpperCase()}
    </span>
  );
};

export const fullAddress = (a) => (a ? [a.line1, a.line2, `${a.city}, ${a.state} ${a.zip}`].filter(Boolean).join(", ") : "");
